export default "__VITE_ASSET__DVROPmqb__"